import React, { useState, useEffect, useContext } from "react";
import Popup from "../../components/_default/Popup";
import AddButton from "../../components/_default/AddButton";
import FormList from "../../components/_forms/FormList";
import DropDown from "../../components/_default/DropDown";
import SearchPage from "../../components/_default/SearchPage";
import "./Forms.scss";
import Icon from "../../components/_default/Icon";
import { getFormsAurum, getFormsCoach } from "../../services/firebase/firestore/getData";
import { deleteFormItemAurum, deleteFormItemCoach } from "../../services/firebase/firestore/deleteData";
import { updateFormItemOrderAurum, updateFormItemOrderCoach } from "../../services/firebase/firestore/updateData";
import { copyFormItemToCoach } from "../../services/firebase/firestore/saveData";
import UserContext from "../../services/context/userContext";
import { useCookies } from "react-cookie";
import aurum from "../../assets/images/aurum.png";
import generateUnique from "../../services/defaultFunctions/generateUnique";
import logo from '../../assets/images/logo.svg';

function Forms({ ...props }) {
  const [cookies, setCookie] = useCookies(["from"]);
  const [formType, setFormType] = useState(props.location.pathname.split("/")[2] ? props.location.pathname.split("/")[2] : "nutrition");
  const [showPopup, setShowPopup] = useState(false);
  const [forms, setForms] = useState(false);
  const [form, setForm] = useState(false);
  const [from, setFrom] = useState(cookies.from ? cookies.from : "aurum");

  const user = useContext(UserContext);

  function sorter(forms) {
    setForm(forms);
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  useEffect(() => {
    setCookie("from", from, { path: "/" });
  }, [from]);

  useEffect(() => {
    getForms((result) => {
      setForms(result);
      getForm(result[from]);
    });
  }, []);

  function getForms(callback) {
    

    getFormsAurum((aurum_result) => {
      getFormsCoach(user.id, (coach_result) => {

        callback({ aurum: aurum_result, coach: coach_result });
      });
    });
  }

  useEffect(() => {
    if (forms) {
      let _forms = { ...forms };

      getForm(_forms[from]);
      
      props.history.replace("/forms/" + formType.toString());
    }
  }, [formType, forms, from]);

  function onDragEnd(result) {
    const { destination, source, type, draggableId } = result;

    if (!result.destination) {
      return;
    }
    const new_order = reorder(form, source.index, destination.index);

    setForm(new_order);
    if (from === "coach") {
      updateFormItemOrderCoach(user.id, formType === "feedback_form" ? formType : "intake_form", formType === "feedback_form" ? false : formType, new_order, () => {
        getForms((result) => {
          setForms(result);
          getForm(result[from]);
        });
      });
    } else {
      updateFormItemOrderAurum(formType === "feedback_form" ? formType : "intake_form", formType === "feedback_form" ? false : formType, new_order, () => {
        getForms((result) => {
          setForms(result);
          getForm(result[from]);
        });
      });
    }
  }

  function removeSet(form_item) {
    if (from === "coach") {
      deleteFormItemCoach(user.id, formType === "feedback_form" ? formType : "intake_form", formType === "feedback_form" ? false : formType, form_item, () => {
        getForms((result) => {
          setForms(result);
          setShowPopup(false);
          getForm(result[from]);
        });
      });
    } else {
      deleteFormItemAurum(formType === "feedback_form" ? formType : "intake_form", formType === "feedback_form" ? false : formType, form_item, () => {
        getForms((result) => {
          setForms(result);
          setShowPopup(false);
          getForm(result[from]);
        });
      });
    }
  }

  function copyItem(item) {
    
    let _item = { ...item };
    if (formType === "feedback_form") {
      _item.id = generateUnique(1, 9);
      copyFormItemToCoach(user.id, "feedback_form", false, _item, () => {
        getForms((result) => {
          setForms(result);
          getForm(result[from]);
          setFrom("coach")
        });
      });
    } else {
      _item.id = generateUnique(1, 9);
      copyFormItemToCoach(user.id, "intake_form", formType, _item, () => {
        getForms((result) => {
          setForms(result);
          getForm(result[from]);
          setFrom("coach")
        });
      });
    }
  }

  function getForm(_forms) {
    let new_form = [..._forms];
    let _form;
    if (formType === "feedback_form") {
      let _found_form = new_form.find((e) => e.id === formType);
      _form = _found_form && _found_form.form ? _found_form.form : false;
    } else {
      let _intake_form = new_form.find((e) => e.id === "intake_form").sub_forms;
      let _found_form = _intake_form.find((e) => e.id === formType);
      _form = _found_form && _found_form.form ? _found_form.form : false;
    }
    
    sorter(_form)
    //setForm(_form);
  }

  function onItemClick(item) {
    props.history.push("/form", { type: formType === "feedback_form" ? formType : "intake_form", sub_type: formType === "feedback_form" ? false : formType, update: true, item: item, from: from });
  }

  function SearchformsByName(e) {
    getFormsAurum((aurum_result) => {
      getFormsCoach(user.id, (coach_result) => {
        let result = { aurum: aurum_result, coach: coach_result };
        let finalresult = { aurum: [
          {id: "intake_form", name: "Intake Form", sub_forms: [
            {name: "Nutrition", id:"nutrition", form: []},
            {name: "Coach", id:"coach", form: []},
            {name: "Goals", id:"goals", form: []},
            {name: "Lifestyle", id:"lifestyle", form: []},
            {name: "Medical", id:"medical", form: []},
            
          ]},
          {id: "feedback_form", name: "Feedback Form", sub_forms: false, form: []}
        ], coach: [
          {id: "intake_form", name: "Intake Form", sub_forms: [
            {name: "Nutrition", id:"nutrition", form: []},
            {name: "Coach", id:"coach", form: []},
            {name: "Goals", id:"goals", form: []},
            {name: "Lifestyle", id:"lifestyle", form: []},
            {name: "Medical", id:"medical", form: []},
            
          ]},
          {id: "feedback_form", name: "Feedback Form", sub_forms: false, form: []}
        ]};
        
        result.aurum.map((types) => {
          if(types.id === "feedback_form") {
            types.form.map((item) => {
              if(item.question.toLowerCase().includes(e.target.value.toLowerCase())) {
                finalresult.aurum.find(x => x.id === "feedback_form").form.push(item)
              }
            })
          }else if(types.id === "intake_form") {
            types.sub_forms.map((item) => {
              item.form.map((formItem) => {
                if(formItem.question.toLowerCase().includes(e.target.value.toLowerCase())) {
                  finalresult.aurum.find(x => x.id === "intake_form").sub_forms.find(x => x.id === item.id).form.push(formItem);
                }
              })
            })
          }
        })

        result.coach.map((types) => {
          if(types.id === "feedback_form") {
            types.form.map((item) => {
              if(item.question.toLowerCase().includes(e.target.value.toLowerCase())) {
                finalresult.coach.find(x => x.id === "feedback_form").form.push(item)
              }

            })
          }else if(types.id === "intake_form") {
            types.sub_forms.map((item) => {
              item.form.map((formItem) => {
                if(formItem.question.toLowerCase().includes(e.target.value.toLowerCase())) {
                  finalresult.coach.find(x => x.id === "intake_form").sub_forms.find(x => x.id === item.id).form.push(formItem);
                }
              })
            })
          }
        })
        setForms(finalresult);
        getForm(finalresult[from]);
      });
    });
  } 

  return (
    <div className="c-page-wrapper c-page-dashboard" style={{justifyContent: 'flex-start'}}>
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav">
            <h1 className="c-header-title">Forms</h1>
            <ul className="c-header-nav-wrapper">
              <li className={from === "aurum" ? "--active" : ""} onClick={() => setFrom("aurum")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
                <p>Aurum</p>
              </li>
              <li className={from === "coach" ? "--active" : ""} onClick={() => setFrom("coach")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
                  <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>
                </div>
                <p>{user.first_name}</p>
              </li>
            </ul>
          </div>
          <div className="c-header-add">
            <AddButton text="New Question" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/form", { type: formType === "feedback_form" ? formType : "intake_form", sub_type: formType === "feedback_form" ? false : formType, update: false, from: from })} />
          </div>
          <div className="c-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>

      <div className="c-page-wrapper--forms">
          <div className="c-form-submenu">
            {forms &&
              forms[from].map((item, idx) => {
                let form_check = "feedback_form";
                if (item.sub_forms) {
                  form_check = item.sub_forms.find((e) => e.id === formType) ? item.sub_forms.find((e) => e.id === formType).id : item.id;
                }
                return (
                  <div key={idx} className="flex-box">
                    <div  className={formType === form_check ? "c-side-form-menu-header --active" : "c-side-form-menu-header"} onClick={() => setFormType(item.sub_forms ? item.sub_forms[0].id : "feedback_form")}>
                      <div className="c-side-form-menu-header-title">
                        
                        <h3>{item.name}</h3>
                      </div>
                    </div>
                    {item.sub_forms && (
                      <ul>
                        {item.sub_forms.map((item, idx) => (
                          <li key={idx} className={formType === item.id ? "--active" : ""} onClick={() => setFormType(item.id)}>
                            <p>{item.name}</p>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
          </div>
        <div className="c-page-main--exercises">
          <div className="c-forms-header">
            <div className="c-page-forms">
              {/* <h1 style={{ textTransform: "capitalize" }}>{formType.replace("_", " ")}</h1> */}
            </div>
            
          </div>
          <div className="c-exercise-finder">
            <SearchPage placeholder="Search form"  onChange={(e) => {SearchformsByName(e)}} />
            <div className="c-dropdown-holder">
            </div>
          </div>
          <FormList onDragEnd={onDragEnd} copyItem={copyItem} from={from} form={form} removeItem={(e) => setShowPopup({ item: e })} onClick={(e) => onItemClick(e)} />
        </div>
        
      </div>
      {showPopup && <Popup title={"Remove Question"} button="Remove" deletePopup={true} description={"Are you sure you want to remove this question? This can not be undone."} onCancel={() => setShowPopup(false)} onAction={() => removeSet(showPopup)} />}
    </div>
  );
}

export default Forms;
